<template>
  <vs-sidebar click-not-close parent="#user-app" :hidden-background="true" default-index="1" color="primary"
              class="user-sidebar email-view-sidebar items-no-padding"
              v-model="isSidebarActive" position-right>

    <div class="w-full flex items-center h-12">
      <div class="w-full flex items-center justify-between px-4 py-2 sm:py-4 d-theme-dark-bg">
        <div class="flex">
          <div class="flex items-center">
            <h4 v-if="userId > 0">
              {{ $t('pages.users.titleEdit', {id: user.id, displayName: user.dataGeneral.displayName}) }}
            </h4>
            <h4 v-else>
              {{ $t('pages.users.titleAdd') }}
            </h4>
          </div>
        </div>

        <div class="ml-10">
          <div class="flex items-baseline">
            <feather-icon icon="XIcon" @click="closeSideBar" class="cursor-pointer mr-4" svg-classes="w-6 h-6" />
          </div>
        </div>
      </div>
    </div>

    <vs-divider class="p-0 m-0"></vs-divider>

    <div class="p-2" v-if="loaded">
      <vs-tabs position="left" class="tabs-shadow-none" id="users-tabs" alignment="fixed" ref="editUser">
        <!-- GENERAL -->
        <vs-tab icon-pack="feather" icon="icon-user" :label="!isSmallerScreen ? $t('menus.user.general') : ''">
          <div class="tab-general m-0 md:ml-4 md:mt-0">
            <user-general :user-id="user.id" v-model="user.dataGeneral" :verified-account="user.verified_at != null"
                          @submitData="submitData"/>
          </div>
        </vs-tab>
        <vs-tab icon-pack="feather" icon="icon-info" :label="!isSmallerScreen ? $t('menus.user.info') : ''">
          <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
            <user-info v-model="user.dataInfo" @submitData="submitData"/>
          </div>
        </vs-tab>
        <vs-tab icon-pack="feather" icon="icon-map" :label="!isSmallerScreen ? $t('menus.user.address') : ''">
          <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
            <user-address v-model="user.dataAddress" save-button @submitData="submitData" force-scroll/>
          </div>
        </vs-tab>

        <vs-tab icon-pack="feather" icon="icon-user-check" :label="!isSmallerScreen ? $t('menus.user.role') : ''">
          <user-roles v-model="user.roles" :capabilities.sync="user.dataCapabilities" @submitData="submitData" />
        </vs-tab>

        <vs-tab icon-pack="feather" icon="icon-lock" :label="!isSmallerScreen ? $t('menus.user.password') : ''">
          <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
            <user-change-password :user-id="user.id"/>
          </div>
        </vs-tab>
      </vs-tabs>
    </div>
  </vs-sidebar>
</template>

<script>
import UserGeneral from "@/views/profileSettings/UserGeneral";
import UserInfo from '@/views/profileSettings/UserInfo';
import UserAddress from '@/views/profileSettings/UserAddress';
import UserChangePassword from '@/views/profileSettings/ChangePassword.vue';
import UserRoles from "@/views/users/UserRoles";

import {User} from "@/models/User.model";
import UserService from "@/services/User.service";
import {showErrorNotify, showSuccessNotify} from "@/helpers/functionsHelpers";

export default {
  name: 'user-sidebar',
  components: {
    UserRoles,
    UserGeneral,
    UserInfo,
    UserChangePassword,
    UserAddress,
  },
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    userId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      user: null,
      loaded: false,

      //https://michaelnthiessen.com/force-re-render/
      updateGeneral: 0,
      updateInfo: 0,
      updateAddress: 0,
    }
  },
  watch: {
    userId() {
      this.loaded = false;
      this.getUser().then(() => {
        this.loaded = true;
      });
    },
    isSidebarActive(val) {
      console.log('isSidebarActive => ', val);
    }
  },
  computed: {
    scrollbarTag() {
      return this.$store.getters.scrollbarTag
    },
    isSmallerScreen() {
      return this.$store.state.isSmallerScreen();
    },
  },
  methods: {
    getUser() {
      return this.$store.dispatch('Users/lookupUser', this.userId).then((response) => {
        if (response) {
          this.user = User.FromObj(response);
        } else {
          this.user = new User();
        }
      }, error => {
        showErrorNotify(this, error);
      });
    },
    submitData() {
      UserService.set(this.user).then((response) => {
        this.$store.dispatch('Users/setUser', response).then(() => {
          this.closeSideBar();
          showSuccessNotify(this, this.$t('pages.users.userEditedMsgSuccess'));
        });
      }, (error) => {
        showErrorNotify(this, error);
      });
    },
    submitCancel() {
      this.closeSideBar();
    },
    closeSideBar() {
      this.$emit('closeSidebar');
    }
  },
  mounted() {
    this.getUser().then(() => {
      this.loaded = true;
    });
  },
}
</script>

<style lang="scss">
#user-app {
  .user-sidebar .vs-sidebar {
    max-width: 100%;
    z-index: 25 !important;
  }

   .content-scroll-area {
    height: calc(100% - 4rem - 0.5rem);
  }
}

#users-tabs {
  .vs-tabs--content {
    padding: 0 0 0 0;
  }


}
</style>
